import { LocationHomeIcon } from '@vlabs/icons';
import { Link } from '@vlabs/uikit/components/controls/link/Link';
import type { LinkProps } from '@vlabs/uikit/components/controls/link/Link';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath } from 'react-router-dom';

import { useGetDepartment } from '@vlabs/api/artemy/client';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './GoToDepartmentLink.module.sass';
import type { GoToDepartment } from './types';

type GoToDepartmentLinkProps = GoToDepartment & LinkProps & WithDataTestid;

const displayName = 'GoToDepartmentLink';
const testid = buildTestid(displayName);

function GoToDepartmentLink({
  departmentId,
  'data-testid': dataTestId = undefined,
  ...props
}: GoToDepartmentLinkProps): JSX.Element | null {
  const { data: department } = useGetDepartment(departmentId);
  return (
    <div className={st.GoToDepartment}>
      <LocationHomeIcon className={st.HomeIcon} />
      <Link
        kind="secondary"
        to={{
          pathname: generatePath(routes.departments.list),
          state: { departmentId },
        }}
        {...testid(dataTestId)}
        {...props}
      >
        {department?.name ?? departmentId}
      </Link>
    </div>
  );
}

GoToDepartmentLink.displayName = displayName;

export { GoToDepartmentLink };
